import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { isDefined } from '@grandvisionhq/utils';
import { UnavailableLineItemsContainer } from '../../LineItems/containers/UnavailableLineItemsContainer.js';
import { VisualLineItemsContainer } from '../../LineItems/VisualLineItemsContainer/VisualLineItemsContainer.js';
import '../../../slots/context.js';
import '../../../slots/summary-slot/context.js';
import { useCartHeaderActionSlots } from '../../../slots/header-slot/context.js';
import { FooterContainer } from '../../Footer/FooterContainer.js';

const Cart = ({ cartId , lineItems , visualLineItems , unavailableLineItems , readOnly , hasSubscription , labels , deliveryResolver , policyItems , handleCheckoutNavigation , donation  })=>{
    const { Slots: CartHeaderComponents  } = useCartHeaderActionSlots();
    // This will be used when the basic variant of the DeliveryIndicator is enabled
    const availability = lineItems.map((item)=>item.availability
    );
    // This will be used if the full date variant of the DeliveryIndicator is enabled (feature toggle)
    const deliveryItems = lineItems.map((item)=>{
        if ('sku' in item) {
            return {
                sku: item.sku,
                quantity: item.quantity
            };
        }
    }).filter(isDefined);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('cart', {
            'cart--read-only': readOnly
        }),
        "data-t": "cart"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        component: "h1",
        className: "cart__heading"
    }, labels.cartTitle), /*#__PURE__*/ React.createElement("div", {
        className: "cart__content"
    }, CartHeaderComponents.FirstComponent ? /*#__PURE__*/ React.createElement(CartHeaderComponents.FirstComponent, {
        cartId: cartId
    }) : !!lineItems.length && /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        items: deliveryItems,
        availability: availability,
        deliveryResolver: deliveryResolver
    }), /*#__PURE__*/ React.createElement(VisualLineItemsContainer, {
        lineItems: visualLineItems,
        readOnly: readOnly
    }), /*#__PURE__*/ React.createElement(UnavailableLineItemsContainer, {
        unavailableLineItems: unavailableLineItems,
        labels: labels
    })), /*#__PURE__*/ React.createElement(FooterContainer, swcHelpers.extends({
        readOnly: readOnly,
        hasSubscription: hasSubscription,
        policyItems: policyItems,
        unavailableLineItems: unavailableLineItems,
        handleCheckoutNavigation: handleCheckoutNavigation
    }, (donation === null || donation === void 0 ? void 0 : donation.amount) && {
        donationAmount: donation.amount
    })));
};

export { Cart };
//# sourceMappingURL=Cart.js.map
